import React from "react";
import "./Charts.css";

const WIDTH = 200;
const HEIGHT = 40;
const PAD = 3;

/**
 * Small trend line for a stat card. Carries shape only — the figure beside it
 * is the value, so there are no axes or labels.
 */
export default function Sparkline({ values, color, fill = true }) {
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;

  const x = (index) => (index / (values.length - 1)) * WIDTH;
  const y = (value) =>
    HEIGHT - PAD - ((value - min) / span) * (HEIGHT - PAD * 2);

  const line = values
    .map((value, index) => `${index === 0 ? "M" : "L"}${x(index)},${y(value)}`)
    .join(" ");

  const gradientId = `spark-${color.replace("#", "")}`;

  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      className="spark"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      {fill && (
        <>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity="0.22" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
          <path
            d={`${line} L${WIDTH},${HEIGHT} L0,${HEIGHT} Z`}
            fill={`url(#${gradientId})`}
          />
        </>
      )}
      <path
        d={line}
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
